import { render, staticRenderFns } from "./Prorak2.vue?vue&type=template&id=2392949a&scoped=true"
import script from "./Prorak2.vue?vue&type=script&lang=js"
export * from "./Prorak2.vue?vue&type=script&lang=js"
import style0 from "./Prorak2.vue?vue&type=style&index=0&id=2392949a&prod&lang=scss&scoped=true"
import style1 from "./Prorak2.vue?vue&type=style&index=1&id=2392949a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392949a",
  null
  
)

export default component.exports